<template>
    <b-modal size="sm" id="modal-center" centered header-class="numpad-modal" hide-footer>
        <template #modal-header="">
            <b-container>
                <b-row class="mb-2">
                    <b-col sm="12" class="text-sm-center text-white modal-payment-text">Payment</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col sm="12" class="text-sm-center text-white modal-payment-value">Total amount due {{totalAmount}}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <p class="numpad-output">{{numbers}}</p>
                </b-row>
                <b-row>
                    <b-col sm="9">
                        <b-row>
                            <b-col class="p-1 calc-number" sm="4" v-for="(keypad, index) in keypad" :key="index">
                                <b-button class="btn-number-pad" @click="handleClickNumber(keypad.value)">{{keypad.label}}</b-button>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="3">
                        <b-row class="h-50">
                            <b-col class="p-1" md="12">
                                <b-button class="btn-clear h-100 btn-danger" @click="handleClear">CLEAR</b-button>
                            </b-col>
                        </b-row>
                        <b-row class="h-50">
                            <b-col class="p-1" md="12">
                                <b-button class="btn-ok h-100 btn-success" @click="handleSubmit">OK</b-button>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-container>
        </template>
    </b-modal>
</template>
<script>
    import lottoService from '@/services/lotto.service';
    const TICKET_PRICE = process.env.VUE_APP_TICKET_PRICE;
    import toolService from '@/services/tool.service';
    export default {
        props: {
        },
        data() {
            return {
                numbers: '',
                keypad: [
                    {label:'1', value: 1},
                    {label:'2', value: 2},
                    {label:'3', value: 3},
                    {label:'4', value: 4},
                    {label:'5', value: 5},
                    {label:'6', value: 6},
                    {label:'7', value: 7},
                    {label:'8', value: 8},
                    {label:'9', value: 9},
                    {label:'0', value: 0},
                    {label:'.', value: '.'},
                    {label:'00', value: '00'}
                ],
            }
        },
        computed: {
            totalAmount () {
                return toolService.formatAmount(parseFloat(this.$store.state.totalAmount));
            }
        },
        // created() {
        //     const numberOfTickets = this.$store.getters.getTicketsLength;
        //     console.log('ticket', numberOfTickets);
        //     const totalWager = numberOfTickets*TICKET_PRICE;
        //     this.totalAmount = toolService.formatAmount(parseFloat(totalWager));
        // },
        methods: {
            handleClickNumber(number) {
                this.numbers = this.numbers + number;
            },
            handleClear() {
                this.numbers = '';
            },
            handleSubmit() {
                if (this.numbers && parseFloat(this.numbers) >= this.$store.state.totalAmount) {
                    const numberOfTickets = this.$store.state.tickets.length;
                    const totalWager = numberOfTickets*TICKET_PRICE;
                    lottoService.confirmTicket(this.$store.state.type, totalWager, this.$store.state.tickets).then((res) => {
                            if (res.status === 'success') {
                                this.$bvToast.toast("Tickets Confirmed", {
                                    title: 'Successful',
                                    variant: 'success',
                                    solid: true,
                                    autoHideDelay: 5000
                                });
                                const ref = res.data.ref;
                                // '/transaction-overview'
                                this.$router.push({name: 'TransactionOverview', query: {ref: ref, received: this.numbers} });
                            } else {
                                const message = res.message;
                                this.$bvToast.toast(message, {
                                    title: 'Failed',
                                    variant: 'danger',
                                    solid: true,
                                    autoHideDelay: 5000
                                })
                            }
                        },
                        () => this.$bvToast.toast('Confirm Failed!', {
                            title: 'Failed',
                            variant: 'danger',
                            solid: true,
                            autoHideDelay: 5000
                        }));
                } else {
                    this.$bvToast.toast("Invalid Amount", {
                        title: 'Failed',
                        variant: 'danger',
                        solid: true,
                        autoHideDelay: 5000
                    });
                }
            }
        }
    }
</script>
<style scoped lang="scss">
    ::v-deep {
        .modal-payment-text {
            font-size: 30px;
            font-weight: 400;
        }
        .modal-payment-value {
            font-size: 16px;
            font-weight: 400;
        }
    }
</style>